export const reset = "\x1B[0m";
export const magenta = `${reset}\x1B[34;1m`;
export const green = `${reset}\x1B[32;1m`
export const bold = `${reset}\x1B[1m`;
export const underline = `${reset}\x1B[4m`;
export const boldAndUnderline = `${reset}\x1B[1m\x1B[4m`;
